import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import {
  INITIAL_GIFTED_PARAMS_STATE,
  INITIAL_REFERRAL_PARAMS_STATE,
  QUERY_PARAMS
} from "./constants";

export const useSignupPageParams = () => {
  const [isReady, setIsReady] = useState(false);
  const [referralParams, setReferralParams] = useState(
    INITIAL_REFERRAL_PARAMS_STATE
  );
  const [giftedParams, setGiftedParams] = useState(INITIAL_GIFTED_PARAMS_STATE);
  const location = useLocation();

  const defineReferralParamsIfExists = useCallback((params) => {
    const referralCodeParam = params.get(QUERY_PARAMS.REFERRAL_CODE);
    if (!referralCodeParam) return;

    setReferralParams({
      isReferralPage: true,
      referralCode: referralCodeParam
    });
  }, []);

  const defineGiftedParamsIfExists = useCallback((params) => {
    const isGifted = params.get(QUERY_PARAMS.GIFTING);
    const gifter = params.get(QUERY_PARAMS.GIFTER);
    const email = params.get(QUERY_PARAMS.EMAIL);

    const isValidGift = isGifted && gifter && email;
    if (!isValidGift) return;

    setGiftedParams({
      isGifted: true,
      gifter,
      email
    });
  }, []);

  useEffect(() => {
    if (!location) return;

    const queryParams = new URLSearchParams(location.search);
    defineReferralParamsIfExists(queryParams);
    defineGiftedParamsIfExists(queryParams);
    setIsReady(true);
  }, [location, defineReferralParamsIfExists, defineGiftedParamsIfExists]);

  return {
    isReady,
    referralParams,
    giftedParams
  };
};
